import { clsx } from "clsx";
import type { SyncStatus } from "../sync/docManager";
import { useT } from "../i18n";

const LABEL: Record<SyncStatus, string> = {
  offline: "sync.offline",
  connecting: "sync.connecting",
  syncing: "sync.syncing",
  synced: "sync.synced",
  error: "sync.error",
  forbidden: "sync.forbidden",
};

export function SyncBadge({ status }: { status: SyncStatus }) {
  const t = useT();
  return (
    <span
      data-testid="sync-status"
      data-status={status}
      className={clsx(
        "kss-pill",
        status === "synced" && "bg-ok-tint text-ok",
        status === "offline" && "border-neutral-200 bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-200",
        (status === "connecting" || status === "syncing") && "bg-warn-tint text-warn",
        (status === "error" || status === "forbidden") && "bg-err-tint text-err",
      )}
    >
      <span className={clsx("h-1.5 w-1.5 rounded-full bg-current", (status === "connecting" || status === "syncing") && "motion-safe:animate-pulse")} />
      {t(LABEL[status])}
    </span>
  );
}
